module.exports = __webpack_public_path__ + "static/media/aa5.5299a8a5.jpg";